import TelegramAnalytics from '@telegram-apps/analytics'

export default defineNuxtPlugin((nuxtApp) => {
  const RuntimeConfig = useRuntimeConfig()

  const telegramAnalytics = TelegramAnalytics.init({
    token: RuntimeConfig.public.TELEGRAM_ANALYTICS_TOKEN,
    appName: RuntimeConfig.public.TELEGRAM_APP_NAME,
  })

  nuxtApp.provide('telegramAnalytics', telegramAnalytics)
})
